export default __webpack_public_path__ + "static/media/amazon-icon.1591be66.svg";